// src/components/ui/SpinnerIcon.tsx
import { LoaderCircle } from 'lucide-react';
import React from 'react';
import { cn } from '@/lib/utils';

interface SpinnerIconProps {
  size?: number;
  className?: string;
}

/**
 * Spinner icon component for inline loading indicators
 * Follows Next.js best practices for accessibility and performance
 */
const SpinnerIcon: React.FC<SpinnerIconProps> = ({ size = 6, className = '' }) => {
  const sizeClass = `h-${size} w-${size}`;

  return <LoaderCircle className={cn('animate-spin', sizeClass, className)} />;
};

SpinnerIcon.displayName = 'SpinnerIcon';

export default SpinnerIcon;

